import { UAError } from './consts/error';
import type { ErrorType } from './fetch';

// The record moved under us: a write landed against a newer version than the one this payload was
// built on. Callers decide what to do with that — replay against the fresh version, or refetch and
// let the next attempt build on what's actually there.
export function isVersionError(error: unknown): boolean {
  const payload = (error as ErrorType<{ currentVersion?: number }> | undefined)?.payload;
  return payload?.errorCode === UAError.STALE_OBJECT;
}
